import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-44" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-45" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-46" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-lime-dark" data-id="element-47" data-mp="57ebob4uv5ec">
            The Tennis Ready Difference
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black uppercase leading-[1.08] tracking-tight text-brand sm:text-5xl" data-id="element-48" data-mp="3rgyrz6n48mdx">
            From an Overwhelmed Coach to a{' '}
            <span className="text-lime-dark" data-id="element-49" data-mp="3ifr65o1sde0q">Confident Professional.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-50" data-mp="3ihloqvpl4u1n">
            Give your practices more structure, your players faster improvement,
            and yourself the freedom to enjoy coaching again.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-brand/10 bg-white sm:grid-cols-3" data-id="element-51" data-mp="1j9m6ujrd90br">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-brand/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-52" data-mp="1t0gt3o4m3zx7" data-mpi={index}>
              <dt className="sr-only" data-id="element-53" data-mp="wazfmmze19ky">{stat.label}</dt>
              <dd data-id="element-54" data-mp="wciv4bd7zglo">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-55" data-mp="wd2dtuap290r">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-56" data-mp="15b4lutsui1xj">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-57" data-mp="2gprm2jfq0q0s">
          <div className="grid md:grid-cols-2" data-id="element-58" data-mp="2oq7cqvfscsm8">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-59" data-mp="2otlga706r7v9">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-60" data-mp="2srj69c1s5xzp">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-61" data-mp="2xq46vcky2joo" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-62" data-mp="32oxlj8bywgqf">
                The cost of improvising
              </span>
              <h3 className="mt-3 font-display text-2xl font-black uppercase tracking-wide text-ink" data-id="element-63" data-mp="2a1kw8qef9utf">
                Before
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-64" data-mp="2ezcr9tad5x1u">
                What planning every practice from scratch quietly costs you.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-65" data-mp="1mc8si61v6eyi">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-full bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-66" data-mp="1rak16dgfajf5">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-67" data-mp="1euamibiw5m01" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-68" data-mp="10thqfmcxyiut">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-lime text-brand" data-id="element-69" data-mp="10v1558iy8luh">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-70" data-mp="r3of8mgpo5r3" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-lime-dark" data-id="element-71" data-mp="r1c1ymlwejkd">
                The Tennis Ready system
              </span>
              <h3 className="mt-3 font-display text-2xl font-black uppercase tracking-wide text-brand" data-id="element-72" data-mp="h47d2f0o49zv">
                With Tennis Ready
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-73" data-mp="11utdybi75bl6">
                Walk onto every court knowing exactly what to do.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-74" data-mp="16vqrubw6bjgv">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-lime-light px-4 py-3 text-sm font-medium text-ink" data-id="element-75" data-mp="t1zjv7y3c7n9">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-lime-dark" aria-hidden="true" data-id="element-76" data-mp="j2qqohb1ux1y" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-brand/5 bg-cream px-6 py-4 text-center font-display text-xs font-bold uppercase tracking-[0.18em] text-brand" data-id="element-77" data-mp="e5qmkbxrg4dh">
            Less planning · More coaching · Better players
          </p>
        </div>
      </div>
    </section>;
}